// extracted by mini-css-extract-plugin
export default {"container":"ServiceData_container__bhBGX","img":"ServiceData_img__YEWNs","desc":"ServiceData_desc__Dxx5C"};